<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 9.50012C19.5 14.8677 14.3856 19.8943 12.6036 21.4829C12.2544 21.7941 11.7455 21.7941 11.3964 21.4829C9.61436 19.8943 4.5 14.8677 4.5 9.50012C4.5 5.00012 8 2.50012 12 2.50012C16 2.50012 19.5 5.00012 19.5 9.50012Z"
      :stroke="color"
      stroke-width="2"
    />
    <circle
      cx="12"
      cy="9.00012"
      r="2"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgLocation',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>
